export const BASIC_INFO_LOAD = 'BASIC_INFO_LOAD';
export const BASIC_INFO_LOAD_SUCCESS = 'BASIC_INFO_LOAD_SUCCESS';
export const BASIC_INFO_LOAD_FAIL = 'BASIC_INFO_LOAD_FAIL';

export const DRIVER_LIST_LOAD = 'DRIVER_LIST_LOAD';
export const DRIVER_LIST_LOAD_SUCCESS = 'DRIVER_LIST_LOAD_SUCCESS';
export const DRIVER_LIST_LOAD_FAIL = 'DRIVER_LIST_LOAD_FAIL';

export const OPEN_DRIVER_MODAL = 'OPEN_DRIVER_MODAL';

export const HANDLE_ADD_EDIT_DRIVER_DIALOG = 'HANDLE_ADD_EDIT_DRIVER_DIALOG';

export const DRIVER_INFO_LOAD = 'DRIVER_INFO_LOAD';
export const DRIVER_INFO_LOAD_SUCCESS = 'DRIVER_INFO_LOAD_SUCCESS';
export const DRIVER_INFO_LOAD_FAIL = 'DRIVER_INFO_LOAD_FAIL';

export const DRIVER_INFO_ADD = 'DRIVER_INFO_ADD';
export const DRIVER_INFO_ADD_SUCCESS = 'DRIVER_INFO_ADD_SUCCESS';
export const DRIVER_INFO_ADD_FAIL = 'DRIVER_INFO_ADD_FAIL';

export const DRIVER_INFO_UPDATE = 'DRIVER_INFO_UPDATE';
export const DRIVER_INFO_UPDATE_SUCCESS = 'DRIVER_INFO_UPDATE_SUCCESS';
export const DRIVER_INFO_UPDATE_FAIL = 'DRIVER_INFO_UPDATE_FAIL';

export const DRIVER_SALARY_TYPE_FIX_LOAD = 'DRIVER_SALARY_TYPE_FIX_LOAD';
export const DRIVER_SALARY_TYPE_FIX_LOAD_SUCCESS = 'DRIVER_SALARY_TYPE_FIX_LOAD_SUCCESS';
export const DRIVER_SALARY_TYPE_FIX_LOAD_FAIL = 'DRIVER_SALARY_TYPE_FIX_LOAD_FAIL';

export const WORKING_AREA_LOAD = 'WORKING_AREA_LOAD';
export const WORKING_AREA_LOAD_SUCCESS = 'WORKING_AREA_LOAD_SUCCESS';
export const WORKING_AREA_LOAD_FAIL = 'WORKING_AREA_LOAD_FAIL';

export const GET_PREDEFINED_DRIVER_NOTE = 'GET_PREDEFINED_DRIVER_NOTE';
export const GET_PREDEFINED_DRIVER_NOTE_SUCCESS = 'GET_PREDEFINED_DRIVER_NOTE_SUCCESS';
export const GET_PREDEFINED_DRIVER_NOTE_FAIL = 'GET_PREDEFINED_DRIVER_NOTE_FAIL';

export const WAREHOUSE_LOAD = 'WAREHOUSE_LOAD';
export const WAREHOUSE_LOAD_SUCCESS = 'WAREHOUSE_LOAD_SUCCESS';
export const WAREHOUSE_LOAD_FAIL = 'WAREHOUSE_LOAD_FAIL';

export const PARCEL_RETURN_REFERENCE_LOAD = 'PARCEL_RETURN_REFERENCE_LOAD';
export const PARCEL_RETURN_REFERENCE_LOAD_SUCCESS = 'PARCEL_RETURN_REFERENCE_LOAD_SUCCESS';
export const PARCEL_RETURN_REFERENCE_LOAD_FAIL = 'PARCEL_RETURN_REFERENCE_LOAD_FAIL';

export const ADD_PARCEL_RETURN = 'ADD_PARCEL_RETURN';
export const ADD_PARCEL_RETURN_SUCCESS = 'ADD_PARCEL_RETURN_SUCCESS';
export const ADD_PARCEL_RETURN_FAIL = 'ADD_PARCEL_RETURN_FAIL';

export const ORDER_INFO_LOAD = 'ORDER_INFO_LOAD';
export const ORDER_INFO_LOAD_SUCCESS = 'ORDER_INFO_LOAD_SUCCESS';
export const ORDER_INFO_LOAD_FAIL = 'ORDER_INFO_LOAD_FAIL';

export const ORDER_INFO_UPDATE = 'ORDER_INFO_UPDATE';
export const ORDER_INFO_UPDATE_SUCCESS = 'ORDER_INFO_UPDATE_SUCCESS';
export const ORDER_INFO_UPDATE_FAIL = 'ORDER_INFO_UPDATE_FAIL';

export const ORDER_INFO_DETAIL_LOAD = 'ORDER_INFO_DETAIL_LOAD';
export const ORDER_INFO_DETAIL_LOAD_SUCCESS = 'ORDER_INFO_DETAIL_LOAD_SUCCESS';
export const ORDER_INFO_DETAIL_LOAD_FAIL = 'ORDER_INFO_DETAIL_LOAD_FAIL';

export const OPEN_FIELD_CHANGE_DIALOG = 'OPEN_FIELD_CHANGE_DIALOG';
export const OPEN_DRIVER_TRANSFER_DIALOG = 'OPEN_DRIVER_TRANSFER_DIALOG';
export const OPEN_SECONDARY_DELIVERY_DIALOG = 'OPEN_SECONDARY_DELIVERY_DIALOG';

export const SHOW_ALERT_SNACK_BAR = 'SHOW_ALERT_SNACK_BAR'; 
export const HIDE_ALERT_SNACK_BAR = 'HIDE_ALERT_SNACK_BAR';

export const NEXT_TRANSITION_LOAD = 'NEXT_TRANSITION_LOAD';
export const NEXT_TRANSITION_LOAD_SUCCESS = 'NEXT_TRANSITION_LOAD_SUCCESS';
export const NEXT_TRANSITION_LOAD_FAIL = 'NEXT_TRANSITION_LOAD_FAIL';

export const ORDER_SIGNATURE_PHOTO_LOAD = 'ORDER_SIGNATURE_PHOTO_LOAD';
export const ORDER_SIGNATURE_PHOTO_LOAD_SUCCESS = 'ORDER_SIGNATURE_PHOTO_LOAD_SUCCESS';
export const ORDER_SIGNATURE_PHOTO_LOAD_FAIL = 'ORDER_SIGNATURE_PHOTO_LOAD_FAIL';

export const ORDER_SIGNATURE_PHOTO_UPDATE = 'ORDER_SIGNATURE_PHOTO_UPDATE';
export const ORDER_SIGNATURE_PHOTO_UPDATE_SUCCESS = 'ORDER_SIGNATURE_PHOTO_UPDATE_SUCCESS';
export const ORDER_SIGNATURE_PHOTO_UPDATE_FAIL = 'ORDER_SIGNATURE_PHOTO_UPDATE_FAIL';

export const INSERT_DRIVER_ORDER = 'INSERT_DRIVER_ORDER';
export const INSERT_DRIVER_ORDER_SUCCESS = 'INSERT_DRIVER_ORDER_SUCCESS';
export const INSERT_DRIVER_ORDER_FAIL = 'INSERT_DRIVER_ORDER_FAIL';

export const ORDER_JUMP_IN_LINE_TRANSFER = 'ORDER_JUMP_IN_LINE_TRANSFER';
export const ORDER_JUMP_IN_LINE_TRANSFER_SUCCESS = 'ORDER_JUMP_IN_LINE_TRANSFER_SUCCESS';
export const ORDER_JUMP_IN_LINE_TRANSFER_FAIL = 'ORDER_JUMP_IN_LINE_TRANSFER_FAIL';

export const UPDATE_SCAN_STATUS = 'UPDATE_SCAN_STATUS';
export const UPDATE_SCAN_STATUS_SUCCESS = 'UPDATE_SCAN_STATUS_SUCCESS';
export const UPDATE_SCAN_STATUS_FAIL = 'UPDATE_SCAN_STATUS_FAIL';

export const CREATE_SECONDARY_DELIVERY = 'CREATE_SECONDARY_DELIVERY';
export const CREATE_SECONDARY_DELIVERY_SUCCESS = 'CREATE_SECONDARY_DELIVERY_SUCCESS';
export const CREATE_SECONDARY_DELIVERY_FAIL = 'CREATE_SECONDARY_DELIVERY_FAIL';

export const ADD_CUSTOM_COMPLAIN = 'ADD_CUSTOM_COMPLAIN';
export const ADD_CUSTOM_COMPLAIN_SUCCESS = 'ADD_CUSTOM_COMPLAIN_SUCCESS';
export const ADD_CUSTOM_COMPLAIN_FAIL = 'ADD_CUSTOM_COMPLAIN_FAIL';

export const GET_BATCH_BY_PERIOD = "GET_BATCH_BY_PERIOD";
export const GET_BATCH_BY_PERIOD_SUCCESS = "GET_BATCH_BY_PERIOD_SUCCESS";
export const GET_BATCH_BY_PERIOD_FAIL = "GET_BATCH_BY_PERIOD_FAIL";

export const GET_ALL_CARGO_STATES = "GET_ALL_CARGO_STATES";
export const GET_ALL_CARGO_STATES_SUCCESS = "GET_ALL_CARGO_STATES_SUCCESS";
export const GET_ALL_CARGO_STATES_FAIL = "GET_ALL_CARGO_STATES_FAIL";

export const GET_MAWB_STATISTICS = "GET_MAWB_STATISTICS";
export const GET_MAWB_STATISTICS_SUCCESS = "GET_MAWB_STATISTICS_SUCCESS";
export const GET_MAWB_STATISTICS_FAIL = "GET_MAWB_STATISTICS_FAIL";

export const UPDATE_HEAD_CELLS = "UPDATE_HEAD_CELLS";

export const UPDATE_SCANNING_STATUS = "UPDATE_SCANNING_STATUS";
export const UPDATE_SCANNING_STATUS_SUCCESS = "UPDATE_SCANNING_STATUS_SUCCESS";
export const UPDATE_SCANNING_STATUS_FAIL = "UPDATE_SCANNING_STATUS_FAIL";

export const SETTLE_UNSCANNED_ORDERS = "SETTLE_UNSCANNED_ORDERS";
export const SETTLE_UNSCANNED_ORDERS_SUCCESS = "SETTLE_UNSCANNED_ORDERS_SUCCESS";
export const SETTLE_UNSCANNED_ORDERS_FAIL = "SETTLE_UNSCANNED_ORDERS_FAIL";

export const CREATE_SUB_BATCH = "CREATE_SUB_BATCH";
export const CREATE_SUB_BATCH_SUCCESS = "CREATE_SUB_BATCH_SUCCESS";
export const CREATE_SUB_BATCH_FAIL = "CREATE_SUB_BATCH_FAIL";

export const GET_BLIND_SCAN_BATCH = "CREATE_GET_BLIND_SCAN_BATCHSUB_BATCH";
export const GET_BLIND_SCAN_BATCH_SUCCESS = "GET_BLIND_SCAN_BATCH_SUCCESS";
export const GET_BLIND_SCAN_BATCH_FAIL = "GET_BLIND_SCAN_BATCH_FAIL";

export const SET_BLIND_SCAN_BATCH = "SET_BLIND_SCAN_BATCH";
export const SET_BLIND_SCAN_BATCH_SUCCESS = "SET_BLIND_SCAN_BATCH_SUCCESS";
export const SET_BLIND_SCAN_BATCH_FAIL = "SET_BLIND_SCAN_BATCH_FAIL";

export const GET_NEXT_OPERATIONS = "GET_NEXT_OPERATIONS";
export const GET_NEXT_OPERATIONS_SUCCESS = "GET_NEXT_OPERATIONS_SUCCESS";
export const GET_NEXT_OPERATIONS_FAIL = "GET_NEXT_OPERATIONS_FAIL";

export const UPDATE_CARGO_TRACKING = "UPDATE_CARGO_TRACKING";
export const UPDATE_CARGO_TRACKING_SUCCESS = "UPDATE_CARGO_TRACKING_SUCCESS";
export const UPDATE_CARGO_TRACKING_FAIL = "UPDATE_CARGO_TRACKING_FAIL";

export const EDIT_ORDER_ADDRESS = "EDIT_ORDER_ADDRESS";
export const EDIT_ORDER_ADDRESS_SUCCESS = "EDIT_ORDER_ADDRESS_SUCCESS";
export const EDIT_ORDER_ADDRESS_FAIL = "EDIT_ORDER_ADDRESS_FAIL";

export const GET_TEAM_LIST = "GET_TEAM_LIST";
export const GET_TEAM_LIST_SUCCESS = "GET_TEAM_LIST_SUCCESS";
export const GET_TEAM_LIST_FAIL = "GET_TEAM_LIST_FAIL";

export const ADD_NEW_DRIVER_TEAM = "ADD_NEW_DRIVER_TEAM";
export const ADD_NEW_DRIVER_TEAM_SUCCESS = "ADD_NEW_DRIVER_TEAM_SUCCESS";
export const ADD_NEW_DRIVER_TEAM_FAIL = "ADD_NEW_DRIVER_TEAM_FAIL";

export const HANDLE_DRIVER_ID = "HANDLE_DRIVER_ID";

export const GET_NEW_STORAGE_INFO = 'GET_NEW_STORAGE_INFO';
export const GET_NEW_STORAGE_INFO_SUCCESS = 'GET_NEW_STORAGE_INFO_SUCCESS';
export const GET_NEW_STORAGE_INFO_FAIL = 'GET_NEW_STORAGE_INFO_FAIL';

export const GET_EXCEPTION_DETAILS = 'GET_EXCEPTION_DETAILS';
export const GET_EXCEPTION_DETAILS_SUCCESS = 'GET_EXCEPTION_DETAILS_SUCCESS';
export const GET_EXCEPTION_DETAILS_FAIL = 'GET_EXCEPTION_DETAILS_FAIL';

export const EDIT_EXCEPTION = 'EDIT_EXCEPTION';
export const EDIT_EXCEPTION_SUCCESS = 'EDIT_EXCEPTION_SUCCESS';
export const EDIT_EXCEPTION_FAIL = 'EDIT_EXCEPTION_FAIL';

export const GET_EXCEPTION_BY_STATE = 'GET_EXCEPTION_BY_STATE';
export const GET_EXCEPTION_BY_STATE_SUCCESS = 'GET_EXCEPTION_BY_STATE_SUCCESS';
export const GET_EXCEPTION_BY_STATE_FAIL = 'GET_EXCEPTION_BY_STATE_FAIL';

export const OPEN_BLIND_SCAN_BATCH_SETTING_DIALOG = 'OPEN_BLIND_SCAN_BATCH_SETTING_DIALOG';

export const LOG_DRIVER_OPERATIONS = 'LOG_DRIVER_OPERATIONS';
export const LOG_DRIVER_OPERATIONS_SUCCESS = 'LOG_DRIVER_OPERATIONS_SUCCESS';
export const LOG_DRIVER_OPERATIONS_FAIL = 'LOG_DRIVER_OPERATIONS_FAIL';

export const CREATE_AGENT_DRIVERS = 'CREATE_AGENT_DRIVERS';
export const CREATE_AGENT_DRIVERS_SUCCESS = 'CREATE_AGENT_DRIVERS_SUCCESS';
export const CREATE_AGENT_DRIVERS_FAIL = 'CREATE_AGENT_DRIVERS_FAIL';

export const DELIVERY_OPERATION = "DELIVERY_OPERATION"
export const DELIVERY_OPERATION_SUCCESS = "DELIVERY_OPERATION_SUCCESS"
export const DELIVERY_OPERATION_FAIL = "DELIVERY_OPERATION_FAIL"